// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-page {
  max-width: 480px;
  margin: 0 auto;
  background: #f5f0e8;
  min-height: 100vh;
  padding-bottom: 40px;
}

.share-back-header {
  padding: 12px 16px;
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
}

.share-back-btn {
  font-size: 14px;
  color: var(--primary);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  transition: all 0.2s;
}

.share-back-btn:hover {
  background: var(--primary-light);
}

.share-loading {
  text-align: center;
  padding: 60px 20px;
  font-size: 16px;
  color: #666;
}
.share-expired {
  text-align: center;
  padding: 80px 20px;
}
.expired-icon {
  font-size: 64px;
  margin-bottom: 24px;
}
.expired-title-bold {
  font-size: 32px;
  font-weight: bold;
  color: #e74c3c;
  margin-bottom: 12px;
}
.expired-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
}
.expired-desc {
  font-size: 18px;
  color: #666;
}
.share-header {
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  padding: 40px 20px 30px;
  text-align: center;
  color: #fff;
}
.share-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255,255,255,0.5);
  margin-bottom: 12px;
}
.share-avatar-placeholder {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.share-name {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 6px;
}
.share-role-tag {
  font-size: 13px;
  padding: 4px 12px;
  background: rgba(255,255,255,0.25);
  border-radius: 16px;
  display: inline-block;
  margin-bottom: 12px;
}
.share-info-row {
  display: flex;
  gap: 12px;
  justify-content: center;
  font-size: 13px;
}
.share-info-item {
  padding: 3px 8px;
  background: rgba(255,255,255,0.15);
  border-radius: 8px;
}
.share-section {
  background: #fff;
  margin: 12px;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.share-section-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}
.share-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.share-label-tag {
  padding: 4px 10px;
  background: #fff0e5;
  color: var(--primary);
  border-radius: 16px;
  font-size: 13px;
}
.share-intro-content {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
}
.share-exp-item {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.share-exp-date {
  font-size: 13px;
  color: var(--primary);
  font-weight: 600;
  margin-bottom: 4px;
}
.share-exp-desc {
  font-size: 14px;
  color: #555;
}
.share-photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.share-photo-item {
  width: 100%;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
}

/* 单张证书全宽展示 */
.share-photo-grid-single {
  display: block;
}
.share-photo-item-large {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/ShareResumePage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,yEAAyE;EACzE,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".share-page {\n  max-width: 480px;\n  margin: 0 auto;\n  background: #f5f0e8;\n  min-height: 100vh;\n  padding-bottom: 40px;\n}\n\n.share-back-header {\n  padding: 12px 16px;\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.share-back-btn {\n  font-size: 14px;\n  color: var(--primary);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s;\n}\n\n.share-back-btn:hover {\n  background: var(--primary-light);\n}\n\n.share-loading {\n  text-align: center;\n  padding: 60px 20px;\n  font-size: 16px;\n  color: #666;\n}\n.share-expired {\n  text-align: center;\n  padding: 80px 20px;\n}\n.expired-icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n}\n.expired-title-bold {\n  font-size: 32px;\n  font-weight: bold;\n  color: #e74c3c;\n  margin-bottom: 12px;\n}\n.expired-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 8px;\n}\n.expired-desc {\n  font-size: 18px;\n  color: #666;\n}\n.share-header {\n  background: linear-gradient(135deg, var(--primary), var(--primary-light));\n  padding: 40px 20px 30px;\n  text-align: center;\n  color: #fff;\n}\n.share-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid rgba(255,255,255,0.5);\n  margin-bottom: 12px;\n}\n.share-avatar-placeholder {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.3);\n  color: #fff;\n  font-size: 32px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 12px;\n}\n.share-name {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.share-role-tag {\n  font-size: 13px;\n  padding: 4px 12px;\n  background: rgba(255,255,255,0.25);\n  border-radius: 16px;\n  display: inline-block;\n  margin-bottom: 12px;\n}\n.share-info-row {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  font-size: 13px;\n}\n.share-info-item {\n  padding: 3px 8px;\n  background: rgba(255,255,255,0.15);\n  border-radius: 8px;\n}\n.share-section {\n  background: #fff;\n  margin: 12px;\n  padding: 16px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n}\n.share-section-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--primary);\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n.share-labels {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.share-label-tag {\n  padding: 4px 10px;\n  background: #fff0e5;\n  color: var(--primary);\n  border-radius: 16px;\n  font-size: 13px;\n}\n.share-intro-content {\n  font-size: 14px;\n  color: #555;\n  line-height: 1.6;\n}\n.share-exp-item {\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f3f4f6;\n}\n.share-exp-date {\n  font-size: 13px;\n  color: var(--primary);\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n.share-exp-desc {\n  font-size: 14px;\n  color: #555;\n}\n.share-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n.share-photo-item {\n  width: 100%;\n  height: 100px;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* 单张证书全宽展示 */\n.share-photo-grid-single {\n  display: block;\n}\n.share-photo-item-large {\n  width: 100%;\n  height: 200px;\n  border-radius: 8px;\n  object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
